import {
  formatCMErrorsToComponent,
  formatResultsToComponent
} from '../formatters';
import { StyledErrors } from './GitstreamResults.style';

const DEFAULT_RESULTS = {
  NO_RESULTS: '',
  LOADING: 'Processing...'
};

const GitstreamResults = ({
  gitstreamResults,
  ruleFileErrors,
  gitstreamErrors
}) => {
  if (gitstreamErrors) {
    return <StyledErrors>Error:&nbsp;{gitstreamErrors}</StyledErrors>;
  }
  if (ruleFileErrors) {
    return <>{formatCMErrorsToComponent(ruleFileErrors)}</>;
  }
  if (!gitstreamResults) {
    return <>{DEFAULT_RESULTS.NO_RESULTS}</>;
  }
  const formattedResult = formatResultsToComponent(gitstreamResults);
  return <>{formattedResult}</>;
};

export default GitstreamResults;
